import { createSelector, DuckSelector } from '@atc/modular-redux';

import { resultsDuckCreator } from 'axl-ducks';

import { invDuckPreset } from '@/ducks/presets/index.js';

const DEFAULT_EMPTY_INVENTORY = {};

const invResultsDuck = resultsDuckCreator({
    ...invDuckPreset,
}).extend({
    selectors: () => ({
        getInvActiveInventory: new DuckSelector((selectors) => createSelector(
            selectors.getActiveInventory,
            ([activeInventory]) => activeInventory || DEFAULT_EMPTY_INVENTORY
        )),
    }),
});

export default invResultsDuck;
